import React, { Suspense, useRef, useMemo } from 'react';

// Conditional WebGL component - only renders if Three.js is available
let WebGLSceneComponent = () => null;

try {
  const { Canvas, useFrame } = require('@react-three/fiber');
  const { BufferGeometry, BufferAttribute, PointsMaterial } = require('three');

  function Particles({ count = 1000 }) {
    const mesh = useRef();

    const particles = useMemo(() => {
      const positions = new Float32Array(count * 3);
      
      for (let i = 0; i < count * 3; i++) {
        positions[i] = (Math.random() - 0.5) * 30;
      }
      
      return positions;
    }, [count]);

    useFrame((state) => {
      if (mesh.current) {
        mesh.current.rotation.x = state.clock.elapsedTime * 0.05;
        mesh.current.rotation.y = state.clock.elapsedTime * 0.1;
      }
    });

    const geometry = useMemo(() => {
      const geom = new BufferGeometry();
      geom.setAttribute('position', new BufferAttribute(particles, 3));
      return geom;
    }, [particles]);

    return (
      <points ref={mesh} geometry={geometry} frustumCulled={false}>
        <pointsMaterial
          transparent
          color="#000000"
          size={1.5}
          sizeAttenuation={true}
          depthWrite={false}
          opacity={0.2}
        />
      </points>
    );
  }

  WebGLSceneComponent = () => {
    return (
      <Canvas
        camera={{ position: [0, 0, 30], fov: 75 }}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        gl={{ alpha: true, antialias: true }}>
        <Suspense fallback={null}>
          <ambientLight intensity={0.5} />
          <Particles count={800} />
        </Suspense>
      </Canvas>
    );
  };
} catch (e) {
  // WebGL libraries not installed - component will render nothing
  console.warn('WebGL libraries not available. Run: npm install three @react-three/fiber');
}

export default WebGLSceneComponent;
